"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var sc = _interopRequireWildcard(require("./IconButton.styles"));

var Icon = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var buttonProps = {
    children: null,
    icon: props.children,
    isFullWidth: false
  };
  return /*#__PURE__*/_react["default"].createElement(sc.IconButton, (0, _extends2["default"])({}, props, buttonProps, {
    ref: ref
  }));
});

Icon.types = {
  kind: constants.kind,
  size: constants.defaultSize
};
var IconPropTypes = {
  /** Body content of the button (an icon). */
  children: _propTypes["default"].node.isRequired,

  /** The visual style of the button. */
  kind: _propTypes["default"].oneOf([Icon.types.kind.DEFAULT, Icon.types.kind.PRIMARY, Icon.types.kind.SECONDARY, Icon.types.kind.DESTRUCTIVE, Icon.types.kind.FLAT, Icon.types.kind.MINOR, Icon.types.kind.LINK]),

  /** Size of the button (font size, min-height, padding, etc). */
  size: _propTypes["default"].oneOf([Icon.types.size.SMALL, Icon.types.size.MEDIUM, Icon.types.size.LARGE])
};
var IconDefaultProps = {
  kind: Icon.types.kind.DEFAULT,
  size: Icon.types.size.MEDIUM
};
Icon.displayName = "Button.Icon";
Icon.propTypes = IconPropTypes;
Icon.defaultProps = IconDefaultProps;
var _default = Icon;
exports["default"] = _default;
//# sourceMappingURL=Icon.js.map